<div class="modal" id="infoboxModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-body text-center text-{{ queue[0]?.style }}">
				<p *ngIf="queue[0]?.icon"><i class="{{ queue[0]?.icon }} fa-5x"></i></p>
				<p [innerHTML]="queue[0]?.text"></p>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="close()">OK</button>
			</div>
		</div>
	</div>
</div>
